import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from 'styled-components';
import AppContext from './AppContext';
import MainApp from './MainApp';
import { BrowserRouter } from './router';
import GlobalStyles from './theme/GlobalStyles';
import { lightTheme, darkTheme } from './theme/themes';

const getInitialTheme = () => {
  if (typeof window === 'undefined') {
    return true;
  }

  const savedTheme = window.localStorage.getItem('portfolio-theme');

  if (savedTheme === 'light') {
    return false;
  }

  if (savedTheme === 'dark') {
    return true;
  }

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? true;
};

function App() {
  const [isDarkMode, setIsDarkMode] = useState(getInitialTheme);

  useEffect(() => {
    window.localStorage.setItem('portfolio-theme', isDarkMode ? 'dark' : 'light');
    document.documentElement.dataset.theme = isDarkMode ? 'dark' : 'light';
  }, [isDarkMode]);

  return (
    <AppContext.Provider
      value={{
        isDarkMode,
        toggleTheme: () => setIsDarkMode((prevState) => !prevState),
      }}
    >
      <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
        <GlobalStyles />
        <div className="App">
          <a className="skip-nav" href="#main-content">Skip to content</a>
          <BrowserRouter>
            <MainApp />
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </AppContext.Provider>
  );
}

export default App;
